export default {
      id: "logo-usage",
      viewBox: "0 0 106 24",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#logo",
      toString: function () {
        return this.url;
      }
    }